module.exports = __webpack_public_path__ + "static/media/135U11_Bedroom.f8e04fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U11_Bedroom.jpg
// module id = 545
// module chunks = 0